import React, { Component } from 'react';
import { connect } from 'react-redux';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import {
  getSingleDevice,
  setPage,
  doLockUnlock,
  doSetWifi,
  patchDeviceParameters,
  doFetchHistoricalEventLogs,
  storeHistoricalEventLogs,
  updateSinglePageSelectedEventLogIndex,
  updateSinglePageDisplayLiveLogs,
  updateSinglePageLocalLogList
} from 'redux/actions';
import {
  swVersionCompare,
  getNumericArraySwVersion,
  getDeviceSwVersion,
  deviceToProductTypeDisplayString,
  checkStringForHTML
} from 'common/utils/helpers';
import { rebootDevice } from 'apis/RebootDevice';
import Toggle from 'components/shared/Toggle/Toggle';
import Modal from 'components/shared/Modal/Modal';
import PasswordInput from 'components/shared/PasswordInput/PasswordInput';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import DropModal from 'components/shared/DropModal/DropModal';
import classnames from 'classnames';
import './DeviceQuickView.css';
import { Status } from 'apis/Status';
import { IconLoader } from 'common/IconLoader';
import LTEDetailsModal from '../LTEDetailsModal/LTEDetailsModal';
import ViewLogModal from '../ViewLogModal/ViewLogModal';
import { shouldShowLogsButton } from '../ViewLogModal/utils';

const NameLabelErrors = {
  NONE: 0,
  HTML_FOUND: 1,
  OVERFLOW: 2
};

class DeviceQuickView extends Component {
  state = {
    rebootModalOpen: false,
    rebooting: false,
    rebootSuccess: false,
    rebootFailed: false,
    lockModalOpen: false,
    unlockModalOpen: false,
    lteDetailsModalOpen: false,
    lockStatus: null,
    errorBoxText: null,
    showErrorBox: false,
    errorReset: false,
    startMode: null,
    showCheck: null,
    checkmarkFade: null,
    isWifiAccessPointModalOpen: false,
    accessPointNameValue: null,
    accessPointPasswordValue: null,
    accessModalStatus: Status.NONE,
    accessModalErrorMessage: null,
    timersModalStatus: Status.NONE,
    timersModalErrorMessage: null,
    wifiEnabledTimerValue: 1,
    wifiDisabledTimerValue: 1,
    nameLabelEditMode: false,
    nameLabelValue: null,
    renderedWithDevice: false,
    nameLabelError: NameLabelErrors.NONE,
    renderKey: 0,

    rebootPermissions: false,
    lockPermissions: false,
    unlockPermissions: false,
    setWifiPermissions: false,
    heightSaver: 0,
    widthSaver: 0,
    viewLogModalOpen: false
  };

  constructor(props) {
    super(props);

    this.heightSave = 0;
    this.widthSave = 0;

    this.nameLabelEditorInput = React.createRef();
  }

  launchTimersModal() {
    !this.state.isWifiTimersModalOpen && this.setState({ isWifiTimersModalOpen: true });

    const hasReportedWifi = this.props.device && this.props.device.parameters && this.props.device.parameters.wifi;
    const hasWifiEnableTimerValue = hasReportedWifi && this.props.device.parameters.wifi.enableTimer;
    const hasWifiDisableTimerValue = hasReportedWifi && this.props.device.parameters.wifi.disableTimer;

    hasWifiEnableTimerValue
      ? this.setState({ wifiEnabledTimerValue: hasWifiEnableTimerValue / 60 })
      : this.setState({ wifiEnabledTimerValue: 0 });
    hasWifiDisableTimerValue
      ? this.setState({ wifiDisabledTimerValue: hasWifiDisableTimerValue / 60 })
      : this.setState({ wifiDisabledTimerValue: 0 });
  }

  applyWifiAccessPoint() {
    if (this.state.accessModalStatus !== Status.NONE) return;

    this.setState({ accessModalStatus: Status.PENDING });

    this.props.dispatch(
      doSetWifi(
        this.props.id,
        null,
        this.state.accessPointNameValue,
        this.state.accessPointPasswordValue,
        null,
        null,
        (result) => {
          if (result && result.customStatus && result.customStatus.status && result.customStatus.status === 'error') {
            this.setState({ accessModalStatus: Status.FAILURE, accessModalErrorMessage: result.customStatus.message });
          } else {
            this.setState({ accessModalStatus: Status.SUCCESS });
            this.props.dispatch(getSingleDevice(this.props.id));
          }
        },
        (error) => {
          this.setState({ accessModalStatus: Status.FAILURE });
          let errorText = error && error.message ? error.message : JSON.stringify(error);

          this.setState({ accessModalErrorMessage: errorText ? errorText : 'Unknown error' });
        }
      )
    );
  }

  applyWifiTimers() {
    this.setState({ timersModalStatus: Status.PENDING });

    this.props.dispatch(
      doSetWifi(
        this.props.id,
        null,
        null,
        null,
        this.state.wifiEnabledTimerValue * 60,
        this.state.wifiDisabledTimerValue * 60,
        (result) => {
          if (result && result.customStatus && result.customStatus.status && result.customStatus.status === 'error') {
            this.setState({ timersModalStatus: Status.FAILURE, timersModalErrorMessage: result.customStatus.message });
          } else {
            this.setState({ timersModalStatus: Status.SUCCESS });
            this.props.dispatch(getSingleDevice(this.props.id));
          }
        },
        (error) => {
          this.setState({ timersModalStatus: Status.FAILURE });
          let errorText = error && error.message ? error.message : JSON.stringify(error);
          this.setState({ timersModalErrorMessage: errorText ? errorText : 'Unknown error' });
        }
      )
    );
  }

  applyDeviceName() {
    this.props.dispatch(
      patchDeviceParameters(
        this.props.device.id,
        { tags: { userLabel: this.state.nameLabelValue } },
        this.patchErrorCallback
      )
    );
    this.setState({ nameLabelEditMode: false });
  }

  applyNameLabelChanges(evt) {
    let targetString = evt.target.value;

    this.setState({ nameLabelValue: targetString });

    if (targetString.length > 100) {
      this.setState(
        {
          errorBoxText: 'Number of characters should be less than 100',
          nameLabelError: NameLabelErrors.OVERFLOW,
          showErrorBox: true
        },
        () => {
          this.setState({ renderKey: this.state.renderKey + 1 });
        }
      );
    } else if (checkStringForHTML(targetString)) {
      this.setState(
        { errorBoxText: 'HTML detected in name', nameLabelError: NameLabelErrors.HTML_FOUND, showErrorBox: true },
        () => {
          this.setState({ renderKey: this.state.renderKey + 1 });
        }
      );
    } else {
      this.setState({ nameLabelError: NameLabelErrors.NONE, errorBoxText: null, showErrorBox: false }, () => {
        this.setState({ renderKey: this.state.renderKey + 1 });
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(setPage('SingleDevicePage'));

    if (this.props.permissions) {
      if (!this.state.rebootPermissions && this.props.permissions.includes('cm_reboot')) {
        this.setState({ rebootPermissions: true });
      }

      if (!this.state.lockPermissions && this.props.permissions.includes('cm_remote_lock')) {
        this.setState({ lockPermissions: true });
      }

      if (!this.state.unlockPermissions && this.props.permissions.includes('cm_remote_unlock')) {
        this.setState({ unlockPermissions: true });
      }

      if (!this.state.setWifiPermissions && this.props.permissions.includes('cm_set_wifi')) {
        this.setState({ setWifiPermissions: true });
      }

      if (!this.state.editNamePermissions && this.props.permissions.includes('cm_userlabel_edit')) {
        this.setState({ editNamePermissions: true });
      }
    }
  }

  componentWillUnmount() {
    if (this.revertAccessApplyTextTimer != null) {
      clearTimeout(this.revertAccessApplyTextTimer);
    }

    if (this.revertTimerApplyTextTimer != null) {
      clearTimeout(this.revertTimerApplyTextTimer);
    }

    this.props.dispatch(updateSinglePageDisplayLiveLogs(false));
    this.props.dispatch(updateSinglePageSelectedEventLogIndex(this.props.id, 0));
  }

  componentDidUpdate(prevProps, prevState) {
    const { historicalEventLogs, selectedEventLogIndex, dispatch, device } = this.props;
    if (prevProps.historicalEventLogs !== historicalEventLogs) {
      let events =
        historicalEventLogs &&
        historicalEventLogs[selectedEventLogIndex] &&
        historicalEventLogs[selectedEventLogIndex].events
          ? historicalEventLogs[selectedEventLogIndex].events
          : [];
      dispatch(updateSinglePageLocalLogList(events));
    }

    if (device != null) {
      if (this.state.rebootSuccess && device.connectionState === 'Disconnected') {
        this.setState({ rebootSuccess: false });
      }

      if (this.state.nameLabelValue == null) {
        if (device.tags != null && device.tags.userLabel != null)
          this.setState({ nameLabelValue: device.tags.userLabel });
      }
    }

    if (this.state.accessModalStatus === Status.SUCCESS) {
      this.revertAccessApplyTextTimer = setTimeout(() => {
        this.setState(() => ({ accessModalStatus: Status.NONE }));
      }, 2000);
    }

    if (this.state.timersModalStatus === Status.SUCCESS) {
      this.revertTimerApplyTextTimer = setTimeout(() => {
        this.setState(() => ({ timersModalStatus: Status.NONE }));
      }, 2000);
    }
  }

  closeRebootModal = () => {
    this.setState({ rebootModalOpen: false });
  };

  closeAccessModal = () => {
    this.setState({
      isWifiAccessPointModalOpen: false,
      accessModalStatus: Status.NONE
    });
  };

  closeWiFiTimersModal = () => {
    this.setState({ isWifiTimersModalOpen: false });
  };

  closeLTEDetailsModal = () => {
    this.setState({ lteDetailsModalOpen: false });
  };

  closeViewLogModalOpen = () => {
    this.setState({ viewLogModalOpen: false });
  };

  render() {
    const hasAdminStateValue =
      this.props.device && this.props.device.parameters && this.props.device.parameters.adminState;

    const hasReportedWifi = this.props.device && this.props.device.parameters && this.props.device.parameters.wifi;

    const hasWifiEnabledValue = hasReportedWifi && this.props.device.parameters.wifi.status;

    let connectionString = 'Unknown';
    if (this.props.device != null) {
      if (this.props.device.connectionState === 'Connected') {
        connectionString = 'Online';
      } else if (this.props.device.connectionState === 'Disconnected') {
        connectionString = 'Offline';
      }
    }

    let button = null;
    if (this.state.rebooting) {
      button = (
        <button aria-label="Reboot" className="Global_ThinBlueButton DeviceQuickView_RebootButton" disabled={true}>
          <img className="LoadingIcon" src={IconLoader.icon_spinner_small} alt={'loading icon'} />
        </button>
      );
    } else if (this.state.rebootSuccess) {
      button = (
        <div role="alert" className="RebootSuccess">
          <img className="RebootSuccess_Icon" src={IconLoader.icon_reboot_success} alt="success icon" />
          <div className="RebootSuccess_Text">Reboot was successfully initiated</div>
          <div className="RebootSuccess_X_Div">
            <SvgAF
              img={IconLoader.icon_close_circle}
              hover={IconLoader.icon_close_circle_hover}
              onClick={() => {
                this.setState({ rebootSuccess: false, rebootFailed: false });
              }}
            />
          </div>
        </div>
      );
    } else if (this.state.rebootFailed) {
      button = (
        <div role="alert" className="RebootFailed">
          <div className="RebootFailed_Title">Error: </div>
          <div className="RebootFailed_Text">failed to initiate reboot</div>
          <div className="RebootFailed_X_Div">
            <SvgAF
              img={IconLoader.icon_close_circle}
              hover={IconLoader.icon_close_circle_hover}
              onClick={() => {
                this.setState({ rebootSuccess: false, rebootFailed: false });
              }}
            />
          </div>
        </div>
      );
    } else if (connectionString === 'Offline') {
      button = (
        <button className="Global_ThinBlueButton DeviceQuickView_RebootButton" disabled={true}>
          Reboot
        </button>
      );
    } else if (connectionString === 'Online') {
      button = (
        <button
          className="Global_ThinBlueButton DeviceQuickView_RebootButton"
          onClick={() => {
            this.setState({ rebootModalOpen: true });
          }}
          disabled={false}
        >
          Reboot
        </button>
      );
    }

    if (this.state.rebootPermissions === false) {
      button = null;
    }
    const { viewLogModalOpen } = this.state;
    const { hasCmEventLogsPermission } = this.props;

    let rebootModal = null;
    if (this.state.rebootModalOpen) {
      rebootModal = (
        <Modal
          role="alertdialog"
          aria-labelledby="device_reboot_modal_title"
          closeTargetRef={null}
          close={this.closeRebootModal}
          animate={false}
          animateX={false}
          opaque={true}
          height={152}
        >
          <form
            id="rebootFormID"
            name="rebootFormName"
            className="RebootModal"
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <div className="RebootModal_Header_Div">
              <div id="device_reboot_modal_title">Reboot this device?</div>
            </div>
            <div className="RebootModal_Buttons">
              <button
                className="Global_RoundedButton RebootModal_CancelButton"
                onClick={() => {
                  this.setState({ rebootModalOpen: false });
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="rebootSubmitID"
                name="rebootSubmitName"
                className="Global_RoundedButton RebootModal_ConfirmButton"
                onClick={() => {
                  window._mfq = window._mfq || [];
                  window._mfq.push(['formSubmitAttempt', '#rebootFormID']);

                  this.setState({ rebootModalOpen: false, rebooting: true });
                  rebootDevice(this.props.device.id)
                    .then((result) => {
                      if (result.customStatus.status !== 'completed') {
                        throw new Error(result.customStatus.message);
                      }

                      return result;
                    })
                    .then((result) => {
                      console.log('reboot result:', result);
                      this.setState({ rebooting: false, rebootSuccess: true, rebootFailed: false });
                      this.props.dispatch(getSingleDevice(this.props.device.id));
                      window._mfq.push(['formSubmitSuccess', '#rebootFormID']);
                    })
                    .catch((error) => {
                      console.log('reboot result:', error);
                      this.setState({ rebooting: false, rebootSuccess: false, rebootFailed: true });
                      this.props.dispatch(getSingleDevice(this.props.device.id));
                      window._mfq.push(['formSubmitFailure', '#rebootFormID']);
                    });
                }}
              >
                Confirm
              </button>
            </div>
          </form>
        </Modal>
      );
    }

    let accessModal = null;
    if (this.state.isWifiAccessPointModalOpen) {
      accessModal = (
        <Modal
          aria-labelledby="access_point_modal_title"
          closeTargetRef={null}
          close={this.closeAccessModal}
          animate={false}
          animateX={false}
          opaque={true}
          height={302}
        >
          <div className="accessModal">
            <div className="wifiModalHeader">
              <div id="access_point_modal_title" className="wifiModalTitle">
                Access point
              </div>
            </div>
            <div className="wifiModalBody">
              <label htmlFor="access_point_name_input" className="wifiAccessPointTitle">
                Name
              </label>
              <input
                id="access_point_name_input"
                defaultValue={this.state.accessPointNameValue}
                onChange={(evt) => this.setState({ accessPointNameValue: evt.target.value })}
                className="wifiAccessPointInput"
              />

              <label htmlFor="access_point_password_input" className="wifiPasswordTitle">
                Password
              </label>
              <PasswordInput
                id="access_point_password_input"
                showButton
                defaultPassword={this.state.accessPointPasswordValue}
                passwordValue={(val) => this.setState({ accessPointPasswordValue: val })}
              />
            </div>
            <div className="wifiModalFooter">
              {this.state.accessModalStatus !== Status.FAILURE && (
                <div className="wifiModalConfirmSection">
                  <button
                    type="button"
                    onClick={() => {
                      this.setState({
                        isWifiAccessPointModalOpen: false,
                        wifiDisabledTimerValue: 0,
                        wifiEnabledTimerValue: 0
                      });
                    }}
                    className="Global_CancelButton wifiCancelButton"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => this.applyWifiAccessPoint()}
                    className="Global_ApplyButton wifiApplyButton"
                  >
                    {this.state.accessModalStatus === Status.NONE && 'Apply'}
                    {this.state.accessModalStatus === Status.PENDING && (
                      <img alt="" className="Global_Spinner" src={IconLoader.icon_spinner_small} />
                    )}
                    {this.state.accessModalStatus === Status.SUCCESS && 'Applied'}
                  </button>
                </div>
              )}
              {this.state.accessModalStatus === Status.FAILURE && (
                <div role="alert" className="wifiModalErrorBox">
                  <img src={IconLoader.icon_failed_medium} alt="" />
                  <div className="wifiModalErrorMessageBlock">
                    <span>{this.state.accessModalErrorMessage}</span>
                  </div>
                  <SvgAF
                    onClick={() => {
                      this.setState({ accessModalStatus: Status.NONE });
                    }}
                    img={IconLoader.icon_close_mid}
                    hover={IconLoader.icon_close_mid_hover}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal>
      );
    }

    let wifiTimersModal = null;

    if (this.state.isWifiTimersModalOpen) {
      wifiTimersModal = (
        <Modal
          aria-labelledby="timers_modal_title"
          closeTargetRef={null}
          close={this.closeWiFiTimersModal}
          animate={false}
          animateX={false}
          opaque={true}
          height={436}
        >
          <div className="wifiTimersModal">
            <div className="wifiTimerModalHeader">
              <div id="timers_modal_title" className="wifiModalTitle">
                Timers
              </div>
            </div>

            <div className="wifiModalBody">
              <div className="wifiTimerSection">
                <label htmlFor="timers_modal_enabling_input" className="timerSectionHeader">
                  <img src={IconLoader.icon_sandclock} alt="" />
                  <span>Enabling Wi-Fi</span>
                </label>
                <div className="incrementer">
                  <input
                    id="timers_modal_enabling_input"
                    aria-describedby="timers_modal_enabling_message"
                    className="incrementInput"
                    onChange={(evt) => {
                      this.setState({ wifiEnabledTimerValue: evt.target.value });
                    }}
                    value={this.state.wifiEnabledTimerValue}
                    type="text"
                  />
                  <div className="incrementButtons">
                    <div
                      role="button"
                      aria-label="Incrrement"
                      aria-controls="timers_modal_enabling_input"
                      onClick={() => {
                        this.setState({ wifiEnabledTimerValue: this.state.wifiEnabledTimerValue + 1 });
                      }}
                      className="increment"
                    >
                      <SvgAF img={IconLoader.icon_add_time} hover={IconLoader.icon_add_time_hover} />
                    </div>
                    <div
                      role="button"
                      aria-label="Decrement"
                      aria-controls="timers_modal_enabling_input"
                      className="decrement"
                      onClick={() => {
                        this.state.wifiEnabledTimerValue > 1 &&
                          this.setState({ wifiEnabledTimerValue: this.state.wifiEnabledTimerValue - 1 });
                      }}
                    >
                      <SvgAF img={IconLoader.icon_subtract_time} hover={IconLoader.icon_subtract_time_hover} />
                    </div>
                  </div>
                  <span className="metric">minutes</span>
                </div>
                <div id="timers_modal_enabling_message" className="enableTimerDescription">
                  {'Pivot 5G will wait '}
                  <span className="enableTimerVal">{this.state.wifiEnabledTimerValue}</span>
                  {' minutes before enabling Wi-Fi if IBMS cannot be reached after reboot.'}
                </div>
              </div>
              <div className="wifiTimerSection">
                <label htmlFor="timers_modal_disabling_input" className="timerSectionHeader">
                  <img src={IconLoader.icon_sandclock} alt="" />
                  <span>Disabling Wi-Fi</span>
                </label>
                <div className="incrementer">
                  <input
                    id="timers_modal_disabling_input"
                    aria-describedby="timers_modal_disabling_message"
                    className="incrementInput"
                    onChange={(evt) => {
                      this.setState({ wifiDisabledTimerValue: evt.target.value });
                    }}
                    value={this.state.wifiDisabledTimerValue}
                    type="text"
                  />
                  <div className="incrementButtons">
                    <div
                      role="button"
                      aria-label="Increment"
                      aria-controls="timers_modal_disabling_input"
                      onClick={() => {
                        this.setState({ wifiDisabledTimerValue: this.state.wifiDisabledTimerValue + 1 });
                      }}
                      className="increment"
                    >
                      <SvgAF img={IconLoader.icon_add_time} hover={IconLoader.icon_add_time_hover} />
                    </div>
                    <div
                      role="button"
                      aria-label="Decrement"
                      aria-controls="timers_modal_disabling_input"
                      className="decrement"
                      onClick={() => {
                        this.state.wifiDisabledTimerValue > 1 &&
                          this.setState({ wifiDisabledTimerValue: this.state.wifiDisabledTimerValue - 1 });
                      }}
                    >
                      <SvgAF img={IconLoader.icon_subtract_time} hover={IconLoader.icon_subtract_time_hover} />
                    </div>
                  </div>
                  <span className="metric">minutes</span>
                </div>
                <div id="timers_modal_disabling_message" className="disableTimerDescription">
                  {'Once Wi-Fi is turned on, it will stay on for '}
                  <span className="disableTimerVal">{this.state.wifiDisabledTimerValue}</span>
                  {' minutes before being disabled.'}
                </div>
              </div>
            </div>

            <div className="wifiTimerModalFooter">
              {this.state.timersModalStatus !== Status.FAILURE && (
                <div className="wifiTimerModalConfirmSection">
                  <button
                    type="button"
                    onClick={() => {
                      this.setState({
                        isWifiTimersModalOpen: false,
                        accessPointNameValue: null,
                        accessPointPasswordValue: null
                      });
                    }}
                    className="Global_CancelButton wifiCancelButton"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="Global_ApplyButton wifiApplyButton"
                    onClick={() => this.applyWifiTimers()}
                    disabled={
                      isNaN(this.state.wifiEnabledTimerValue) ||
                      isNaN(this.state.wifiDisabledTimerValue) ||
                      this.state.wifiEnabledTimerValue < 1 ||
                      this.state.wifiDisabledTimerValue < 1
                    }
                  >
                    {this.state.timersModalStatus === Status.NONE && 'Apply'}
                    {this.state.timersModalStatus === Status.PENDING && (
                      <img alt="" className="Global_Spinner" src={IconLoader.icon_spinner_small} />
                    )}
                    {this.state.timersModalStatus === Status.SUCCESS && 'Applied'}
                  </button>
                </div>
              )}

              {this.state.timersModalStatus === Status.FAILURE && (
                <div role="alert" className="wifiModalErrorBox">
                  <img src={IconLoader.icon_failed_medium} alt="" />
                  <div className="wifiModalErrorMessageBlock">
                    <span>{this.state.timersModalErrorMessage}</span>
                  </div>
                  <SvgAF
                    onClick={() => {
                      this.setState({ timersModalStatus: Status.NONE });
                    }}
                    img={IconLoader.icon_close_mid}
                    hover={IconLoader.icon_close_mid_hover}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal>
      );
    }

    let ellipsisButton = (
      <div className={'DeviceQuickView_editEllipsis'}>
        <SvgAF img={IconLoader.icon_wifi_showAPN} hover={IconLoader.icon_wifi_showAPN_hover} />
      </div>
    );

    if (this.divElement != null) {
      if (this.divElement.offsetWidth > this.widthSave) {
        this.widthSave = this.divElement.offsetWidth;
      }

      if (this.divElement.offsetHeight > this.heightSave) {
        this.heightSave = this.divElement.offsetHeight;
      }
    }

    return (
      <div
        role="region"
        aria-label="Device quick view"
        className="DeviceQuickView"
        ref={(divElement) => {
          this.divElement = divElement;
        }}
        style={{
          height: this.state.heightSaver ? this.state.heightSaver : null,
          width: this.state.widthSaver ? this.state.widthSaver : null
        }}
      >
        {rebootModal}
        {accessModal}
        {wifiTimersModal}
        {this.state.lteDetailsModalOpen && (
          <LTEDetailsModal device={this.props.device} onClose={this.closeLTEDetailsModal} />
        )}
        {viewLogModalOpen && (
          <ViewLogModal
            onClose={this.closeViewLogModalOpen}
            deviceId={this.props.device?.deviceId}
            deviceConnectionState={this.props.device?.connectionState}
          />
        )}

        {this.props.device && (
          <div className="DeviceQuickView_NameSection">
            <div id="device_name_label" className="nameLabelTitle DeviceQuickView_Header">
              Device name
            </div>
            {!this.state.nameLabelEditMode && (
              <div className="nameLabelDisplayContainer">
                <div aria-labelledby="device_name_label" className="nameLabel">
                  {this.props.device.tags.userLabel ? this.props.device.tags.userLabel : '(No name)'}
                </div>
                {this.state.editNamePermissions && (
                  <div className="nameLabelEditButton">
                    <SvgAF
                      aria-label="Edit name"
                      img={IconLoader.icon_edit_name}
                      hover={IconLoader.icon_edit_name_hover}
                      onClick={() =>
                        this.setState({ nameLabelEditMode: true }, () => {
                          this.nameLabelEditorInput.current?.focus();
                        })
                      }
                    />
                  </div>
                )}
              </div>
            )}
            {this.state.nameLabelEditMode && (
              <div className="nameLabelEditorContainer">
                <div className="nameLabelEditor">
                  <div className="nameLabelCounter">
                    {this.state.nameLabelValue ? this.state.nameLabelValue.length : 0}/100
                  </div>
                  <input
                    aria-labelledby="device_name_label"
                    aria-describedby={this.state.showErrorBox ? 'device_view_error' : undefined}
                    aria-invalid={this.state.nameLabelError !== NameLabelErrors.NONE}
                    className={classnames({ nameLabelError: this.state.nameLabelError !== NameLabelErrors.NONE })}
                    ref={this.nameLabelEditorInput}
                    onChange={(evt) => this.applyNameLabelChanges(evt)}
                    value={this.state.nameLabelValue}
                    type="text"
                  />
                </div>
                <div className="buttonSection">
                  {this.state.nameLabelError === NameLabelErrors.NONE && (
                    <SvgAF
                      aria-label="Apply name changes"
                      img={IconLoader.icon_commit_edit}
                      onClick={() => this.applyDeviceName()}
                    />
                  )}
                  {this.state.nameLabelError !== NameLabelErrors.NONE && (
                    <SvgAF aria-label="Apply name changes" aria-disabled={true} img={IconLoader.icon_commit_disabled} />
                  )}
                  <SvgAF
                    aria-label="Discard name changes"
                    img={IconLoader.icon_cancel_edit}
                    onClick={() => this.setState({ nameLabelEditMode: false, nameLabelValue: '' })}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        <table>
          <tbody>
            <tr className="DeviceQuickView_Header DeviceQuickView_Row">
              <td id="device_id_label">Device ID</td>
              <td id="device_type_label">Type</td>
              <td id="device_connection_status_label">Connection status</td>
            </tr>
            <tr className="DeviceQuickView_Values DeviceQuickView_Row">
              <td aria-labelledby="device_id_label">{this.props.id}</td>
              <td aria-labelledby="device_type_label">{this.props.type}</td>
              <td aria-labelledby="device_connection_status_label">
                <div
                  className={classnames({
                    DeviceQuickView_ConnectionText: true,
                    DeviceQuickView_OfflineText: connectionString === 'Offline'
                  })}
                >
                  <IconAndText
                    onClick={() => {
                      this.setState({ lteDetailsModalOpen: true });
                    }}
                    text={connectionString}
                    tooltip={'See the details of the LTE connection'}
                  />
                </div>
              </td>
            </tr>
            <tr className="DeviceQuickView_SpaceRow DeviceQuickView_Row" />
            {shouldShowLogsButton(this.props.device, hasCmEventLogsPermission) && (
              <tr className="DeviceQuickView_Values DeviceQuickView_Row">
                <td>
                  <div className={classnames({ DeviceQuickView_ViewLogText: true })}>
                    <IconAndText
                      img={IconLoader.icon_log}
                      hoverImg={IconLoader.icon_log_hover}
                      onClick={() => {
                        this.setState({ viewLogModalOpen: true });
                        if (!this.props.historicalFetched) {
                          let deviceId = this.props.device.id;
                          this.props.dispatch(updateSinglePageSelectedEventLogIndex(deviceId, 0));
                          this.props.dispatch(storeHistoricalEventLogs(deviceId, []));
                          this.props.dispatch(
                            doFetchHistoricalEventLogs(
                              deviceId,
                              0,
                              100,
                              'timestamp',
                              'desc',
                              (result) => {
                                this.props.dispatch(storeHistoricalEventLogs(deviceId, result));
                              },
                              (error) => {
                                console.log('doUpdateHistoricalEventLogsError', error);
                              }
                            )
                          );
                        }
                      }}
                      text={'View log'}
                      tooltip={'See the details of the device logs'}
                    />
                  </div>
                </td>
              </tr>
            )}
            <tr className="DeviceQuickView_SpaceRow DeviceQuickView_Row" />
            <tr className="DeviceQuickView_Header DeviceQuickView_Row">
              <td></td>
            </tr>
            {!this.state.showErrorBox && (
              <tr className="DeviceQuickView_Values DeviceQuickView_Row DeviceQuickView_LastRow">
                <td>
                  <Toggle
                    aria-label="Admin state"
                    mode="lockUnlock"
                    device={this.props.device}
                    hasDeviceParameter={hasAdminStateValue}
                    isReportedLeft={
                      hasAdminStateValue &&
                      (this.props.device.parameters.adminState === 'lock' ||
                        this.props.device.parameters.adminState === 'locked')
                    }
                    isReportedRight={
                      hasAdminStateValue &&
                      this.props.device.parameters.adminState !== 'lock' &&
                      this.props.device.parameters.adminState !== 'locked'
                    }
                    targetDeviceValue={hasAdminStateValue ? this.props.device.parameters.adminState : null}
                    leftDeviceValues={['lock', 'locked']}
                    rightDeviceValues={[]}
                    iconLeft={IconLoader.icon_locked}
                    iconLeftPending={IconLoader.icon_locking}
                    iconLeftDisabled={IconLoader.icon_locked_disabled}
                    iconRight={IconLoader.icon_unlocked}
                    iconRightPending={IconLoader.icon_unlocking}
                    iconRightDisabled={IconLoader.icon_unlocked_disabled}
                    leftedText={'Locked'}
                    leftedTextPending={'Locking'}
                    rightedText={'Unlocked'}
                    rightedTextPending={'Unlocking'}
                    leftPermissions={this.state.unlockPermissions}
                    rightPermissions={this.state.lockPermissions}
                    showErrorBox={this.state.showErrorBox}
                    leftToggleFunction={doLockUnlock}
                    leftToggleFunctionParameters={[this.props.id, 'lock']}
                    rightToggleFunction={doLockUnlock}
                    rightToggleFunctionParameters={[this.props.id, 'unlock']}
                    onError={(errorText) =>
                      this.setState({ widthSaver: this.widthSave, heightSaver: this.heightSave }, () => {
                        this.setState({ showErrorBox: true, errorBoxText: errorText });
                      })
                    }
                    hasModal={true}
                    hasCheck
                  />
                </td>
                {this.props.device &&
                  this.props.device.connectionState === 'Connected' &&
                  this.state.setWifiPermissions &&
                  swVersionCompare(getNumericArraySwVersion(getDeviceSwVersion(this.props.device)), [1, 2, 0]) >= 0 &&
                  (deviceToProductTypeDisplayString(this.props.device) === 'Pivot 5G Donor' ||
                    deviceToProductTypeDisplayString(this.props.device) === 'Pivot 5G Service') &&
                  hasWifiEnabledValue && (
                    <td className="setWifiCell">
                      <Toggle
                        aria-label="Wi-Fi"
                        mode="setWifi"
                        device={this.props.device}
                        hasDeviceParameter={hasWifiEnabledValue}
                        isReportedLeft={hasWifiEnabledValue && this.props.device.parameters.wifi.status === 'disabled'}
                        isReportedRight={hasWifiEnabledValue && this.props.device.parameters.wifi.status === 'enabled'}
                        targetDeviceValue={hasWifiEnabledValue ? this.props.device.parameters.wifi.status : null}
                        leftDeviceValues={['disabled']}
                        rightDeviceValues={['enabled']}
                        iconLeft={IconLoader.icon_wifi_disabled}
                        iconLeftPending={IconLoader.icon_wifi_disabling}
                        iconRight={IconLoader.icon_wifi_enabled}
                        iconRightPending={IconLoader.icon_wifi_enabling}
                        leftedText={'Wi-Fi disabled'}
                        rightedText={'Wi-Fi enabled'}
                        leftedTextPending={'Disabling'}
                        rightedTextPending={'Enabling'}
                        leftPermissions={this.state.setWifiPermissions}
                        rightPermissions={this.state.setWifiPermissions}
                        showErrorBox={this.state.showErrorBox}
                        leftToggleFunction={doSetWifi}
                        leftToggleFunctionParameters={[this.props.id, 'disabled', null, null, null, null]}
                        rightToggleFunction={doSetWifi}
                        rightToggleFunctionParameters={[this.props.id, 'enabled', null, null, null, null]}
                        onError={(errorText) =>
                          this.setState({ widthSaver: this.widthSave, heightSaver: this.heightSave }, () => {
                            this.setState({ showErrorBox: true, errorBoxText: errorText });
                          })
                        }
                      />

                      <DropModal aria-label="Show Wi-Fi options" title={ellipsisButton} name={'setWifi'}>
                        <div role="menu" aria-label="Wi-Fi options" className="setWifiDropContainer">
                          <div className="buttonContainer">
                            <button
                              role="menuitem"
                              onClick={() => {
                                !this.state.isWifiAccessPointModalOpen &&
                                  this.setState({ isWifiAccessPointModalOpen: true });

                                const deviceWifiSSID = this.props?.device?.parameters?.wifi?.ssid || '';
                                const deviceWifiPSK = this.props?.device?.parameters?.wifi?.psk || '';
                                this.setState({
                                  accessPointNameValue: deviceWifiSSID,
                                  accessPointPasswordValue: deviceWifiPSK
                                });
                              }}
                            >
                              Access Point
                            </button>
                          </div>
                          {swVersionCompare(
                            getNumericArraySwVersion(getDeviceSwVersion(this.props.device)),
                            [1, 2, 0]
                          ) > 0 && (
                            <div className="buttonContainer">
                              <button role="menuitem" onClick={() => this.launchTimersModal()}>
                                Timers
                              </button>
                            </div>
                          )}
                        </div>
                      </DropModal>
                    </td>
                  )}

                {!this.state.showErrorBox && (
                  <td
                    className={classnames({ DeviceQuickView_RebootDate: true, collapseCell: !this.state.showErrorBox })}
                  ></td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        {this.state.showErrorBox && (
          <div role="alert" className="deviceQuickViewErrorBox">
            <img alt="" src={IconLoader.icon_error_mid}></img>
            <div id="device_view_error">
              <span>{this.state.errorBoxText}</span>
            </div>
            <SvgAF
              onClick={() =>
                this.setState({ showErrorBox: false, errorReset: true }, () => {
                  this.setState({ renderKey: this.state.renderKey + 1 });
                })
              }
              img={IconLoader.icon_close_mid}
              hover={IconLoader.icon_close_mid_hover}
            />
          </div>
        )}

        {!this.state.showErrorBox && button}
      </div>
    );
  }
}

export default connect((store) => {
  const device = store.ui.singleDevicePage.selectedDevice;
  const deviceId = device?.id;
  const historicalStatusName = deviceId && `fetchHistoricalEventLogs-${deviceId}`;
  const hasCmEventLogsPermission = store.data.rolePermissions.permissions.some(
    (permission) => permission === 'cm_eventlog'
  );
  return {
    historicalFetched: historicalStatusName && store.statuses[historicalStatusName] === Status.SUCCESS,
    historicalEventLogs: deviceId && store.data.historicalEventLogs && store.data.historicalEventLogs[deviceId],
    selectedEventLogIndex: deviceId && store.ui.singleDevicePage.selectedEventLogIndexObj[deviceId],
    hasCmEventLogsPermission,
    device
  };
})(DeviceQuickView);
